import { formatISO } from 'date-fns'
import { v4 as uuidV4 } from 'uuid'
import { CreateViewMutationParams } from '../../../queries/view'
import { OpalApiResponseDocument } from '../../../schema'

type Plan = OpalApiResponseDocument<'ReadPlansBFFV1', 200>['data'][number]

export const createResourceObject = ({
  creator,
  endDate,
  startDate,
  title,
}: Omit<CreateViewMutationParams, 'workspaceUuid'>): Plan => ({
  id: 'temp-' + uuidV4(),
  created_at: new Date().toISOString(),
  default_timescale: 'month',
  description: '',
  kind: 'plan',
  title: title,
  end_at: formatISO(endDate),
  start_at: formatISO(startDate),
  parent_block: {
    id: 'temp-' + uuidV4(),
    description: '',
    title: title,
    duration: null,
    end_at: formatISO(endDate),
    start_at: formatISO(startDate),
    color: null,
    plan: null,
    owner: {
      id: creator.uuid,
      full_name: creator.name,
      avatar_url: creator.asset?.url || null,
      legacy_id: creator.legacyId,
    },
    created_at: new Date().toISOString(),
  },
  updated_at: new Date().toISOString(),
  owner: {
    id: creator.uuid,
    full_name: creator.name,
    avatar_url: creator.asset?.url || null,
    legacy_id: creator.legacyId,
  },
  supportive_category_id: '',
})
